import { httpGet } from '../../../../common/util'

export const getHomemadeListByIndex = index => {
    return httpGet({
        url: '/goods/window/data',
        data: {
            ename: 'gczq_model' + (index + 3)
        }
    }).then(({ content }) => {
        return content.filter(i => i.type === 1).sort((a, b) => b.sort - a.sort)
    })
}

export const getDetailImgs = goodsId => {
    return httpGet({
        url: '/goods/detail/' + goodsId
    }).then(({ detailImgs }) => {
        return detailImgs
    })
}